/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { v4 as uuidv4 } from 'uuid';

export const createAlert = (action, alertType) => ({
  id: uuidv4(),
  type: alertType,
  ...action.payload,
});

export const createMessage = (message, error) => ({
  message,
  error,
});
